import './cargaTabla.css';
import axios from 'axios';
import { useMemo, useState } from 'react';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import SolicitudTabla from '../components/reclamos3ro/solicitudes/SolicitudTabla';
import { MultiSelect } from 'react-multi-select-component';
import { ThemeContext } from '../context/Theme';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import Calendar from 'react-calendar';
export default function TablaSolicitudes() {
  const [cookies] = useCookies(['user']);
  const [solicitudes, setSolicitudes] = useState([]);
  const [estados, setEstados] = useState([]);
  const [carga, setCarga] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const estadosN = await axios.get('https://back.agsseguros.online/api/estados/estadosAll');
        setEstados(estadosN.data);
        /*      const solicitudes = await axios.get('https://reclamosback.agsseguros.online/apiReclamos/empleadosSolicitudes/solicitudes');  */
        const solicitudes = await axios.get('https://reclamosback.agsseguros.online/apiReclamos/empleadosSolicitudes/solicitudesEstadoDoc2026');
        setSolicitudes(solicitudes.data);
        setCarga(1);
      } catch (error) {
        console.error('Error fetching data', error);
      }
    };
    fetchData();
  }, []);
  let updatedList = solicitudes;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSolicitud, setSelectedSolicitud] = useState(null);
  //
  const optionsEstado = [
    { label: 'SIN CARGAR', value: 901 },
    { label: 'PENDIENTE DE APROBACION', value: 902 },
    { label: 'DEVOLUCION', value: 903 },
    { label: 'REINGRESO', value: 905 },
    { label: 'CARGADA', value: 904 },
  ];
  const optionsEstadoSiniestro = [
    { label: 'RECLAMO RECIBIDO', value: 301 },
    { label: 'ENVIADO A COTIZAR', value: 302 },
    { label: 'ASIGNADO', value: 303 },
    { label: 'ENVIADO A COMPAÑIA', value: 304 },
    { label: 'RETORNO DE COMPANIA', value: 305 },
    { label: 'DOC EN OFICINA', value: 306 },
    { label: 'IN/REC', value: 307 },
    { label: 'TERMINADO', value: 308 },
    { label: 'RECLAMO CERRADO', value: 309 },
    { label: 'ARCHIVO', value: 310 },
    { label: 'COTIZADO', value: 311 },
    { label: 'LEGALES', value: 400 },
  ];
  const optionsCarpetaArmada = [
    { label: 'CARPETA ARMADA: SI', value: 1 },
    { label: 'CARPETA ARMADA: NO', value: 0 },
  ];
  const optionsTipoReclamante = [
    { label: 'VEHICULO', value: 'VEHICULO' },
    { label: 'MOTO', value: 'MOTO' },
    { label: 'PROPIEDAD', value: 'PROPIEDAD' },
  ];
  const optionsEstadoDoc = [
    { label: 'SIN DOC', value: 0 },
    { label: 'CARGA PARCIAL', value: 1 },
    { label: 'DOC CARGADA', value: 2 },
  ];
  // Date Calendar
  const [value, onChange] = useState(null);
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const day = String(date.getDate()).padStart(2, '0'); // usa getDate() en lugar de getUTCDate()
    const month = String(date.getMonth() + 1).padStart(2, '0'); // usa getMonth() en lugar de getUTCMonth()
    const year = date.getFullYear(); // usa getFullYear() en lugar de getUTCFullYear()
    return `${day}/${month}/${year}`;
  }
  // range calendar
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const handleClick = date => {
    if (!startDate || (startDate && endDate)) {
      setStartDate(date);
      setEndDate(null);
    } else {
      if (date < startDate) {
        setEndDate(startDate);
        setStartDate(date);
      } else {
        setEndDate(date);
      }
    }
  };
  const isInRange = date => {
    if (!startDate) return false;
    if (!endDate) return date.getTime() === startDate.getTime();
    return date >= startDate && date <= endDate;
  };
  const normalizeDate = date => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };
  // filtros
  const [info, setInfo] = useState({
    buscarGeneral: '',
    nroStro: '',
    patenteAseg: '',
    patenteRec: '',
    tipo: [],
    estado: [],
    estadoSiniestro: [],
    carpetaArmada: [],
    estadoDoc: [],
  });
  const conFiltro = () => {
    if (info.buscarGeneral) {
      updatedList = updatedList.filter(d => {
        // Compara todos los campos relevantes que quieras buscar
        return (
          JSON.stringify(d.nroStro).includes(info.buscarGeneral) ||
          (d.patenteAseg && d.patenteAseg.toUpperCase().includes(info.buscarGeneral.toUpperCase())) ||
          (d.patenteRec && d.patenteRec.toUpperCase().includes(info.buscarGeneral.toUpperCase()))
        );
      });
    }
    if (info.nroStro) {
      updatedList = updatedList.filter(d => JSON.stringify(Number(d.nroStro)).includes(Number(info.nroStro)));
    }
    if (info.patenteAseg) {
      updatedList = updatedList.filter(d =>
        JSON.stringify(d.patenteAseg)
          .replace(/[&\\#,+()$~%.'":*?<>{}]/g, '')
          .toUpperCase()
          .includes(info.patenteAseg.toUpperCase())
      );
    }
    if (info.patenteRec) {
      updatedList = updatedList.filter(d =>
        JSON.stringify(d.patenteRec)
          .replace(/[&\\#,+()$~%.'":*?<>{}]/g, '')
          .toUpperCase()
          .includes(info.patenteRec.toUpperCase())
      );
    }
    if (info.tipo.length > 0) {
      updatedList = updatedList.filter(d => {
        return info.tipo.some(ele => {
          return ele.value === d.tipoReclamante;
        });
      });
    }
    if (info.estado.length > 0) {
      updatedList = updatedList.filter(d => {
        return info.estado.some(ele => {
          return ele.value === d.estado;
        });
      });
    }
    if (info.carpetaArmada.length > 0) {
      updatedList = updatedList.filter(d => {
        return info.carpetaArmada.some(ele => {
          return ele.value === d.docOffice;
        });
      });
    }
    if (info.estadoSiniestro.length > 0) {
      updatedList = updatedList.filter(d => {
        return info.estadoSiniestro.some(ele => {
          return ele.value === d.estadoReclamoValor;
        });
      });
    }
    if (info.estadoDoc.length > 0) {
      updatedList = updatedList.filter(d => {
        return info.estadoDoc.some(ele => {
          return ele.value === d.estadoDoc;
        });
      });
    }
    if (!startDate) return;
    const start = normalizeDate(startDate);
    const end = endDate ? normalizeDate(endDate) : start;
    updatedList = updatedList.filter(d => {
      const [day, month, year] = d.fechaSolicitud.split('/').map(Number);
      const itemDate = normalizeDate(new Date(year, month - 1, day));
      return itemDate >= start && itemDate <= end;
    });
  };
  conFiltro();
  const sinFiltrosActivos =
    !info.buscarGeneral &&
    !info.nroStro &&
    !info.patenteAseg &&
    !info.patenteRec &&
    info.tipo.length === 0 &&
    info.estado.length === 0 &&
    info.carpetaArmada.length === 0 &&
    info.estadoSiniestro.length === 0 &&
    (value === null || formatDate(value) === '01/01/1970');
  /*
  const sortedList = [...updatedList].sort((a, b) => {
    const parseDate = str => {
      const [date, time] = str.split(' ');
      const [day, month, year] = date.split('/').map(Number);
      const [hours, minutes, seconds] = time.split(':').map(Number);
      return new Date(year, month - 1, day, hours, minutes, seconds);
    };
    return parseDate(a.ultMod) - parseDate(b.ultMod); // Orden descendente
  });
  */
  const { theme, toggleTheme } = useContext(ThemeContext);
  // sort
  const [sort, setSort] = useState(3);
  const handleSort = col => {
    setSort(prev => {
      if (prev === col) return col + 1;
      if (prev === col + 1) return col;
      return col;
    });
  };
  const renderSortIcon = col => {
    if (sort === col) {
      return <i className='bi bi-sort-up'></i>;
    } else if (sort === col + 1) {
      return <i className='bi bi-sort-down'></i>;
    } else {
      return <i className='bi bi-filter'></i>;
    }
  };
  // rosario
  const codigosA = cookies?.user?.codigosPermitidos;
  const codigosANumeros = codigosA.split(',').map(c => Number(c.trim()));
  if (cookies.user.id === 100) {
    updatedList = updatedList.filter(s => codigosANumeros.includes(s.codp));
  }
  //
  const sortedList = useMemo(() => {
    const list = [...updatedList];
    const parseFecha = f => {
      if (!f) return null;
      const [dia, mes, anio] = f.split('/').map(Number);
      return new Date(anio, mes - 1, dia);
    };
    const parseFechaStro = f => new Date(f);
    const parseUltMod = f => {
      if (!f || f.trim() === '') return new Date(0);
      const [fecha, hora] = f.trim().split(' ');
      if (!fecha) return new Date(0);
      const [dia, mes, anio] = fecha.split('/').map(Number);
      let h = 0,
        m = 0,
        s = 0;
      if (hora) {
        const parts = hora.split(':').map(Number);
        h = parts[0] || 0;
        m = parts[1] || 0;
        s = parts[2] || 0;
      }
      return new Date(anio, mes - 1, dia, h, m, s);
    };
    switch (sort) {
      // NRO STRO
      case 1:
        return list.sort((a, b) => Number(a.nroStro) - Number(b.nroStro));
      case 2:
        return list.sort((a, b) => Number(b.nroStro) - Number(a.nroStro));
      // FECHA INGRESO
      case 3:
        return list.sort((a, b) => {
          const fa = parseFecha(a.fechaSolicitud);
          const fb = parseFecha(b.fechaSolicitud);
          if (!fa && !fb) return 0;
          if (!fa) return 1;
          if (!fb) return -1;
          return fa - fb;
        });
      case 4:
        return list.sort((a, b) => {
          const fa = parseFecha(a.fechaSolicitud);
          const fb = parseFecha(b.fechaSolicitud);
          if (!fa && !fb) return 0;
          if (!fa) return 1;
          if (!fb) return -1;
          return fb - fa;
        });
      // PATENTE ASEG
      case 5:
        return list.sort((a, b) => (a.patenteAseg || '').localeCompare(b.patenteAseg || ''));
      case 6:
        return list.sort((a, b) => (b.patenteAseg || '').localeCompare(a.patenteAseg || ''));
      // FECHA STRO
      case 7:
        return list.sort((a, b) => parseFechaStro(a.fechaStroRec) - parseFechaStro(b.fechaStroRec));
      case 8:
        return list.sort((a, b) => parseFechaStro(b.fechaStroRec) - parseFechaStro(a.fechaStroRec));
      // PATENTE 3RO
      case 9:
        return list.sort((a, b) => (a.patenteRec || '').localeCompare(b.patenteRec || ''));
      case 10:
        return list.sort((a, b) => (b.patenteRec || '').localeCompare(a.patenteRec || ''));
      // ULT MOD
      case 11:
        return list.sort((a, b) => parseUltMod(a.ultMod) - parseUltMod(b.ultMod));
      case 12:
        return list.sort((a, b) => parseUltMod(b.ultMod) - parseUltMod(a.ultMod));
      default:
        return list;
    }
  }, [updatedList, sort]);
  return (
    <>
      <main className={theme === 1 ? 'mainTablaLight' : 'mainTablaDark'} style={{ opacity: isOpen ? 0.3 : 1 }}>
        <div className='headerTablaDarkContainer'>
          <div className='input-icon-containerDark'>
            <i className={theme === 1 ? 'bi bi-search input-iconLight' : 'bi bi-search input-iconDark'}></i>
            <input
              className={theme === 1 ? 'busquedaGeneralLight' : 'busquedaGeneralDark'}
              value={info.buscarGeneral2}
              type='text'
              placeholder='BUSCAR'
              onChange={e => setInfo(prevState => ({ ...prevState, buscarGeneral2: e.target.value }))}
            />
          </div>
          <div className='d-flex align-items-center' style={{ gap: '13px' }}>
            <button className='botonCargaHeaderDark center'>CARGA</button>
            <Link to='/' className='botonTablaHeaderDark center' style={{ textDecoration: 'none' }}>
              TABLA
            </Link>
            {cookies?.user?.area === 'Administracion' ? (
              <Link to='/ajustes' className='botonCargaHeaderDark center' style={{ textDecoration: 'none', width: '60px' }}>
                <i class='bi bi-gear-fill'></i>
              </Link>
            ) : null}
          </div>
        </div>
        <section className='contenedorTablaFiltroDark mb-3'>
          <div style={{ width: '80%' }}>
            <div className='contenedorTablaLight'>
              <div>
                <table>
                  <thead className='tablaHeaderTablaDarkContainer'>
                    <tr>
                      <th className='headerTablaDark' style={{ width: '100px' }}>
                        NRO STRO{' '}
                        <span style={{ cursor: 'pointer' }} onClick={() => handleSort(1)}>
                          {renderSortIcon(1)}
                        </span>
                      </th>
                      <th className='headerTablaDark' style={{ width: '140px' }}>
                        FECHA INGRESO{' '}
                        <span style={{ cursor: 'pointer' }} onClick={() => handleSort(3)}>
                          {renderSortIcon(3)}
                        </span>
                      </th>
                      <th className='headerTablaDark' style={{ width: '120px' }}>
                        PATENTE ASEG{' '}
                        <span style={{ cursor: 'pointer' }} onClick={() => handleSort(5)}>
                          {renderSortIcon(5)}
                        </span>
                      </th>
                      <th className='headerTablaDark' style={{ width: '120px' }}>
                        FECHA STRO{' '}
                        <span style={{ cursor: 'pointer' }} onClick={() => handleSort(7)}>
                          {renderSortIcon(7)}
                        </span>
                      </th>
                      <th className='headerTablaDark' style={{ width: '120px' }}>
                        PATENTE 3RO{' '}
                        <span style={{ cursor: 'pointer' }} onClick={() => handleSort(9)}>
                          {renderSortIcon(9)}
                        </span>
                      </th>
                      <th className='headerTablaDark'>
                        OBSERVACIONES <span style={{ cursor: 'default' }}>{renderSortIcon(null)}</span>
                      </th>
                      <th className='headerTablaDark'>
                        ESTADO <span style={{ cursor: 'default' }}>{renderSortIcon(null)}</span>
                      </th>
                      <th className='headerTablaDark' style={{ width: '100px' }}>
                        C. ARMADA <span style={{ cursor: 'default' }}>{renderSortIcon(null)}</span>
                      </th>
                      <th className='headerTablaDark'>
                        ULT MOD{' '}
                        <span style={{ cursor: 'pointer' }} onClick={() => handleSort(11)}>
                          {renderSortIcon(11)}
                        </span>
                      </th>
                      <th className='col-icon'></th>
                      <th className='col-icon'></th>
                    </tr>
                  </thead>
                </table>
                <div className='tablaBodyDarkContainer my-scrollbar'>
                  <table>
                    <tbody>
                      {sortedList
                        .filter(a => !sinFiltrosActivos || a.estado !== 901)
                        .map(a => (
                          <SolicitudTabla solicitud={a} isOpen={isOpen} setIsOpen={setIsOpen} setSelectedSolicitud={setSelectedSolicitud} theme={theme} estados={estados} />
                        ))}
                      {carga === 0 ? (
                        <div className='center mt-3'>
                          <div className='spinner-border text-success center' role='status'>
                            <span className='visually-hidden center'>Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <section style={{ marginTop: '20px' }}>
              <div className='d-flex paginateTablaDark'>
                <h6>Cantidad total: {updatedList.length}</h6>
                <h6 className='ps-4'>Sin Cargar: {updatedList.filter(d => d.estado === 901).length}</h6>
                <h6 className='ps-4'>Pendiente Aprobacion: {updatedList.filter(d => d.estado === 902).length}</h6>
                <h6 className='ps-4'>Devolucion: {updatedList.filter(d => d.estado === 903).length}</h6>
                <h6 className='ps-4'>Reingreso: {updatedList.filter(d => d.estado === 905).length}</h6>
                <h6 className='ps-4'>Cargado: {updatedList.filter(d => d.estado === 904).length}</h6>
              </div>
              {/*
                <div className='d-flex paginateTablaDark'>
                  <h6 className=''>RR: {updatedList.filter(d => d.estadoReclamoValor === 301).length}</h6>
                  <h6 className='ps-4'>CTZ: {updatedList.filter(d => d.estadoReclamoValor === 302).length}</h6>
                  <h6 className='ps-4'>ASIG: {updatedList.filter(d => d.estadoReclamoValor === 303).length}</h6>
                  <h6 className='ps-4'>ACIA: {updatedList.filter(d => d.estadoReclamoValor === 304).length}</h6>
                  <h6 className='ps-4'>RCIA: {updatedList.filter(d => d.estadoReclamoValor === 305).length}</h6>
                  <h6 className='ps-4'>DOCOF: {updatedList.filter(d => d.estadoReclamoValor === 306).length}</h6>
                  <h6 className='ps-4'>IN/REC: {updatedList.filter(d => d.estadoReclamoValor === 307).length}</h6>
                  <h6 className='ps-4'>RTER: {updatedList.filter(d => d.estadoReclamoValor === 308).length}</h6>
                  <h6 className='ps-4'>RCER: {updatedList.filter(d => d.estadoReclamoValor === 309).length}</h6>
                  <h6 className='ps-4'>RARCH: {updatedList.filter(d => d.estadoReclamoValor === 310).length}</h6>
                  <h6 className='ps-4'>CTZDO: {updatedList.filter(d => d.estadoReclamoValor === 311).length}</h6>
                  <h6 className='ps-4'>LEGAL: {updatedList.filter(d => d.estadoReclamoValor === 400).length}</h6>
                </div>
              */}
            </section>
          </div>
          <section className='contenedorFiltroDark'>
            <div className='filtroCargaCol'>
              <input
                class={theme === 1 ? 'btnBusqueda ps-3' : 'btnBusquedaDark ps-3'}
                type='text'
                placeholder='NRO STRO'
                onChange={e => setInfo(prevState => ({ ...prevState, nroStro: e.target.value }))}></input>
            </div>
            <div className='filtroCargaCol mt-3'>
              <input
                class={theme === 1 ? 'btnBusqueda ps-3' : 'btnBusquedaDark ps-3'}
                type='text'
                placeholder='PATENTE ASEG'
                onChange={e => setInfo(prevState => ({ ...prevState, patenteAseg: e.target.value }))}></input>
            </div>
            <div className='filtroCargaCol mt-3'>
              <input
                class={theme === 1 ? 'btnBusqueda ps-3' : 'btnBusquedaDark ps-3'}
                type='text'
                placeholder='PATENTE REC'
                onChange={e => setInfo(prevState => ({ ...prevState, patenteRec: e.target.value }))}></input>
            </div>
            <div className='filtroCargaCol mt-3'>
              <MultiSelect
                className='w-100'
                options={optionsTipoReclamante}
                value={info.tipo}
                valueRenderer={(selected, _options) => {
                  return selected.length ? selected.map(({ label }) => label) : 'TIPO RECLAMANTE';
                }}
                onChange={e => {
                  setInfo(prevState => ({
                    ...prevState,
                    tipo: e,
                  }));
                }}
              />
            </div>
            <div className='filtroCargaCol mt-3'>
              <MultiSelect
                className='w-100'
                options={optionsEstado}
                value={info.estado}
                valueRenderer={(selected, _options) => {
                  return selected.length ? selected.map(({ label }) => label) : 'ESTADO';
                }}
                onChange={e => {
                  setInfo(prevState => ({
                    ...prevState,
                    estado: e,
                  }));
                }}
              />
            </div>
            <div className='filtroCargaCol mt-3'>
              <MultiSelect
                className='w-100'
                options={optionsEstadoSiniestro}
                value={info.estadoSiniestro}
                valueRenderer={(selected, _options) => {
                  return selected.length ? selected.map(({ label }) => label) : 'ESTADO DE SINIESTRO';
                }}
                onChange={e => {
                  setInfo(prevState => ({
                    ...prevState,
                    estadoSiniestro: e,
                  }));
                }}
              />
            </div>
            <div className='filtroCargaCol mt-3'>
              <MultiSelect
                className='w-100'
                options={optionsCarpetaArmada}
                value={info.carpetaArmada}
                valueRenderer={(selected, _options) => {
                  return selected.length ? selected.map(({ label }) => label) : 'CARPETA ARMADA';
                }}
                onChange={e => {
                  setInfo(prevState => ({
                    ...prevState,
                    carpetaArmada: e,
                  }));
                }}
              />
            </div>
            <div className='filtroCargaCol mt-3'>
              <MultiSelect
                className='w-100'
                options={optionsEstadoDoc}
                value={info.estadoDoc}
                valueRenderer={(selected, _options) => {
                  return selected.length ? selected.map(({ label }) => label) : 'ESTADO DOC RECLAMOS SIN CARGAR';
                }}
                onChange={e => {
                  setInfo(prevState => ({
                    ...prevState,
                    estadoDoc: e,
                    estado: [{ label: 'SIN CARGAR', value: 901 }],
                  }));
                }}
              />
            </div>
            <hr style={{ color: '#7A86A1' }} />
            <div className='center mt-3'>
              <Calendar onClickDay={handleClick} tileClassName={({ date }) => (isInRange(date) ? 'in-range' : '')} className='my-custom-calendar' />
            </div>
            <div className='d-flex gap-2 mt-2'>
              {startDate && (
                <p className='w-100'>
                  Seleccionado: {startDate.toLocaleDateString()} {endDate && `- ${endDate.toLocaleDateString()}`}
                </p>
              )}
            </div>
            <div>
              {' '}
              <button
                className='btn btn-primary btn-sm'
                onClick={() => {
                  setStartDate(null);
                  setEndDate(null);
                }}>
                Quitar Filtro Fecha
              </button>
            </div>
          </section>
        </section>
      </main>
      {/*{isOpen && <ModalSolicitud solicitud={selectedSolicitud} setIsOpen={setIsOpen} />}*/}
    </>
  );
}
